import React from "react";
import type { FC, JSX, PropsWithChildren } from "react";

import classes from "./UniCellBottom.styl";

export interface IBottom extends PropsWithChildren {}

const UniCellBottom: FC<IBottom> = ({ children }): JSX.Element => {
    return (
        <div className={classes.bottom} data-tsid="unicell-bottom-test-id">
            {children}
        </div>
    );
};

UniCellBottom.displayName = "UniCell.Bottom";

export default UniCellBottom;
